(() => {
  const root = window.FobLocks?.root || '/';
  const route = (path) => `${root}${path}`.replace(/\/+/g, '/');
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const status = document.querySelector('[data-cart-status]');
  const money = (cents, currency = 'USD') => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);

  function openCart() {
    if (!drawer || !overlay) return;
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-is-open');
    drawer.querySelector('[data-cart-close]')?.focus();
  }

  function closeCart() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('cart-is-open');
  }

  function renderCart(cart) {
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-label', `Open cart, ${cart.item_count} items`));
    document.querySelector('[data-cart-subtotal]')?.replaceChildren(document.createTextNode(money(cart.total_price, cart.currency)));
    document.querySelectorAll('[data-cart-checkout]').forEach((button) => { button.disabled = cart.item_count === 0; });
    if (!cart.items.length) {
      items.innerHTML = `<p class="cart-empty">Your cart is empty.<br><a href="${escapeHtml(root)}#offer">See the packs</a></p>`;
      return;
    }
    items.innerHTML = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` &middot; ${escapeHtml(item.variant_title)}` : '';
      return `<div class="drawer-item"><div class="drawer-item__top"><strong>${escapeHtml(item.product_title)}${variant}</strong><span>${money(item.final_line_price, cart.currency)}</span></div><div class="drawer-item__controls"><button type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease ${escapeHtml(item.product_title)} quantity">&minus;</button><span>${item.quantity}</span><button type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase ${escapeHtml(item.product_title)} quantity">+</button><button class="drawer-item__remove" type="button" data-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0">Remove</button></div></div>`;
    }).join('');
  }

  async function getCart() {
    const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load the cart.');
    return response.json();
  }

  async function changeCart(key, quantity) {
    const response = await fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Could not update the cart.');
    renderCart(data);
  }

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) { openCart(); return; }
    if (event.target.closest('[data-cart-close]') || event.target.matches('[data-cart-overlay]')) { closeCart(); return; }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      change.disabled = true;
      if (status) status.textContent = '';
      try { await changeCart(change.dataset.key, Number(change.dataset.quantity)); }
      catch (error) { if (status) status.textContent = error.message; }
      return;
    }
    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      quickAdd.disabled = true;
      if (status) status.textContent = '';
      try {
        const response = await fetch(route('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(quickAdd.dataset.variantId), quantity: 1 }] }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Could not add this item.');
        renderCart(await getCart());
        openCart();
      } catch (error) { if (status) status.textContent = error.message; openCart(); }
      finally { quickAdd.disabled = false; }
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.js-add-to-cart');
    if (!form) return;
    if (event.submitter && !event.submitter.matches('[data-ajax-add]')) return;
    event.preventDefault();
    const submit = event.submitter || form.querySelector('[data-ajax-add]');
    if (submit) submit.disabled = true;
    if (status) status.textContent = '';
    try {
      const response = await fetch(route('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not add this item.');
      renderCart(await getCart());
      openCart();
    } catch (error) { if (status) status.textContent = error.message; openCart(); }
    finally { if (submit) submit.disabled = false; }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  // /cart has no page of its own -- forward straight to checkout.
  document.querySelector('[data-checkout-forward]')?.submit();

  document.querySelectorAll('[data-signal-widget]').forEach((widget) => {
    const clock = widget.querySelector('[data-clock]');
    const statusText = widget.querySelector('[data-signal-status]');
    const caption = widget.querySelector('[data-signal-caption]');
    const toggle = widget.querySelector('[data-signal-toggle]');
    const tick = () => { if (clock) clock.textContent = new Date().toLocaleTimeString([], { hour12: false }); };
    tick();
    window.setInterval(tick, 1000);
    toggle?.addEventListener('click', () => {
      const blocked = widget.classList.toggle('is-blocked');
      toggle.textContent = blocked ? 'Take the keys out' : 'Drop keys in the pouch';
      statusText.textContent = blocked ? '○ Signal blocked' : '● Broadcasting — 24/7';
      caption.textContent = blocked ? 'That’s the whole habit. Nothing to relay, nothing to clone, nothing to steal.' : 'While your keys sit near the door, their signal may reach through the wall — and a relay device can extend it.';
    });
  });

  // The demo video autoplays muted. Browsers allow that, but some hold off
  // until the element is on screen, so nudge it when it scrolls into view and
  // pause it again when it leaves. A manual pause is never overridden.
  document.querySelectorAll('[data-autoplay-video]').forEach((video) => {
    const play = () => { const started = video.play(); if (started) started.catch(() => {}); };

    if (!('IntersectionObserver' in window)) { play(); return; }

    let pausedByScroll = false;
    video.addEventListener('pause', () => { if (!pausedByScroll) video.dataset.userPaused = 'true'; });
    video.addEventListener('play', () => { delete video.dataset.userPaused; });

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (video.paused && !video.dataset.userPaused) { pausedByScroll = false; play(); }
        } else if (!video.paused) {
          pausedByScroll = true;
          video.pause();
        }
      });
    }, { threshold: 0.2 }).observe(video);
  });

  const sticky = document.querySelector('[data-sticky-offer]');
  if (sticky) {
    const updateSticky = () => sticky.classList.toggle('is-visible', window.scrollY > 620 && window.innerWidth < 900);
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const container = select.closest('[data-product-section]');
      const price = container?.querySelector('[data-product-price]');
      const button = container?.querySelector('[data-product-submit]');
      if (price) price.textContent = option.dataset.price || '';
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
})();
